<template>
    <el-dialog
        :title="title"
        :visible.sync="show"
        :modal-append-to-body="false"
        :show-close="false"
        class="delsmsDio_box"
        :close-on-click-modal="false"
        :width="width"
        center>
            <div class="foot_box">
                <el-button @click="handleCancel" class="cardCanBtn">Cancel</el-button>
                <el-button v-if="!isLoadingMessage" @click="handleTrigger" class="cardConBtn">
                  {{ btnLabel }}
                </el-button>
                <el-button v-if="isLoadingMessage" class="cardConBtn cursor-disable">
                  <i class="el-icon-loading" style="font-size:20px"></i> {{ btnLabelLoading }}
                </el-button>
            </div>
    </el-dialog>
</template>

<style lang='scss'>
    
</style>

<script>
    export default {
        data() {
            return {
            }
        },
        props: {
            title: {
                default: ''
            },
            width: {
                default: '740px'
            },
            show: {
                default: false,
            },
            isLoadingMessage: {
                default: false
            },
            isActivate: {
                default: 0,
            },
            btnLabel: {
                default: ''
            },
            btnLabelLoading: {
                default: ''
            }
        },
        watch: {
            
        },
        computed: {
            
        },
        methods: {
            handleCancel() {
                this.$emit('close')
            },
            handleTrigger() {
                this.$emit('handleTrigger')
            }
        },
        mounted() {
            
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/modal/messageAlert.vue